import { toast } from "react-toastify";

import { BooleanDictionary } from "../GlobalTypes";
import { DeliveryAddressModel } from "../models/DeliveryAddressModel";
import { PartnerModel } from "../models/PartnerModel";
import ResponseModel from "../models/ResponseModel";
import { logUnknownError, UNKNOWN_ERROR_MESSAGE } from "../services/logger/LoggerService";

export const getLongAddress = (model: DeliveryAddressModel | PartnerModel, showName: boolean = false): string => {
  if (model === undefined || model === null) return "";

  return (
    (model.name && showName ? model.name + ", " : "") +
    (model.postalCode ? model.postalCode + " " : "") +
    (model.city ? model.city + " " : "") +
    (model.streetName ? model.streetName + "" : "") +
    (model.streetType ? "\xa0" + model.streetType + "\xa0" : "") +
    (model.houseNumber ? model.houseNumber + "\x20\x20\x20" : "") +
    (model.building ? model.building + "\xa0ép. " : "") +
    (model.staircase ? model.staircase + "\xa0lh. " : "") +
    (model.floor ? model.floor + "\xa0sz. " : "") +
    (model.door ? model.door + "\xa0a." : "")
  );
};

export const doneChecker = (done: BooleanDictionary): boolean => {
  const keys: string[] = Object.keys(done);
  for (const key of keys) {
    if (!done[key]) {
      return false;
    }
  }
  return true;
};

export const hasApiError = (response: ResponseModel): boolean => {
  if (response.error) {
    const debugRequestId =
      response.debug && typeof response.debug === "object" && "requestId" in response.debug
        ? String(response.debug.requestId)
        : null;
    const userMessage = response.error?.message ?? UNKNOWN_ERROR_MESSAGE;
    if (userMessage === UNKNOWN_ERROR_MESSAGE && !response.debug) {
      logUnknownError("hasApiError", undefined, {
        response,
      });
    }
    toast.error(debugRequestId ? `${userMessage} Hibakód: ${debugRequestId}` : userMessage);
    return true;
  }
  return false;
};
